






















































import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public show = true;
  public modal = false;
  public modals = false;
  public mounted() {
    if (this.$route.path == "/home/index" || this.$route.path == "/") {
      this.show = true;
    } else {
      this.show = false;
    }
  }
  @Watch("$route")
  public change() {
    if (this.$route.path == "/home/index" || this.$route.path == "/") {
      this.show = true;
    } else {
      this.show = false;
    }
  }
}
